export default __webpack_public_path__ + "static/logo-e867044c5aaef8b940819e51e8b37581.png";